import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const AvalancheLogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="evenodd"><rect fill="#E84142" height={24} rx={0} width={24} /><path d="M15.878 11.832a.587.587 0 0 1 .534 0c.152.077.27.278.505.675l.02.032 1.67 2.86.025.041c.232.4.35.604.341.772a.59.59 0 0 1-.268.466c-.147.097-.395.097-.887.097h-3.493c-.39 0-.6-.01-.729-.094a.597.597 0 0 1-.268-.466c-.009-.172.113-.383.357-.803l.006-.01 1.665-2.86c.245-.421.369-.63.522-.71Zm-3.589-7.285c.156.08.28.295.525.725l1.182 2.063.006.011c.264.462.398.696.457.942a1.75 1.75 0 0 1 0 .82c-.06.247-.192.483-.46.951l-3.02 5.34-.008.013c-.266.466-.401.702-.588.88a1.758 1.758 0 0 1-.716.416c-.19.052-.399.064-.74.067H6.271c-.49 0-.731 0-.879-.094a.592.592 0 0 1-.268-.463c-.009-.174.112-.386.354-.81l5.75-10.136c.245-.43.368-.646.525-.725a.593.593 0 0 1 .536 0Z" fill="#FFF" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const AvalancheLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm16.412 11.832a.587.587 0 0 0-.534 0c-.153.08-.277.289-.522.71l-1.665 2.86-.006.01c-.244.42-.366.63-.357.803.012.189.11.363.268.466.129.084.339.093.73.094h3.647c.39 0 .601-.01.732-.097a.59.59 0 0 0 .268-.466c.009-.168-.11-.372-.341-.772l-.024-.041-1.672-2.86-.019-.032c-.235-.397-.353-.598-.505-.675Zm-4.123-7.285a.593.593 0 0 0-.536 0c-.157.08-.28.295-.525.725l-5.75 10.136c-.242.424-.363.636-.354.81.012.189.109.36.268.463.148.094.39.094.879.094h2.656c.341-.003.55-.015.74-.067.268-.08.513-.222.716-.416.187-.178.322-.414.588-.88l.008-.013 3.02-5.34c.268-.468.4-.704.46-.952a1.75 1.75 0 0 0 0-.82c-.059-.245-.193-.48-.457-.941l-.006-.01-1.182-2.064c-.245-.43-.369-.646-.525-.725Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};